"use strict";
import {http} from '../../../core'
import Config from "../../../app.config";
const RequestService = http.create()
const RequestServiceBase = http.create({ baseURL: Config.BASE_API });
export default {
    // 获取部门树顶级节点
    treeTop: function(params) {
        return RequestServiceBase.get('itsm/v2/organization/department/tree/top', params)
    },
    // 获取部门树子节点
    treeChildren: function(params) {
        return RequestServiceBase.get('itsm/v2/organization/department/tree/children', params)
    },
    // 获取树节点用户
    // treeUser: function(params) {
    //     return RequestServiceBase.get('itsm/v2/organization/department/tree/user', params)
    // },
    // 新增部门
    departmentAdd: function(params) {
        return RequestServiceBase.post('itsm/v2/organization/department/add', params)
    },
    // 新增服务组
    groupAdd: function(params) {
        return RequestService.post('organization/group/add', params)
    },
    // 服务组详情
    groupDetail: function(params) {
        return RequestService.get('organization/group/detail', params)
    },
    // 编辑部门
    departmentUpdate: function(params) {
        return RequestServiceBase.post('itsm/v2/organization/department/update', params)
    },
    // 编辑服务组
    groupUpdate: function(params) {
        return RequestService.post('organization/group/update', params)
    },
    // 删除部门
    departmentDelete: function(params) {
        return RequestServiceBase.post('itsm/v2/organization/department/delete', params)
    },
    // 服务组删除用户
    userGroupDelete: function(params) {
        return RequestServiceBase.post('itsm/v2/organization/group/user_group/delete', params)
    },
    // 删除服务组
    groupDelete: function(params) {
        return RequestServiceBase.post('itsm/v2/organization/group/delete', params)
    },
     // 获取部门用户
    departmentUser: function(params) {
        return RequestServiceBase.get('itsm/v2/organization/user/department_user', params)
    },
    // 获取部门用户组
    groupUser: function(params) {
        return RequestServiceBase.post('itsm/v2/organization/user/group_user', params)
    },
    //修改审批优先级
    groupPriorityEdit: function(params) {
        return RequestServiceBase.post('itsm/v2/organization/user/group_user/update', params)
    },
     // 用户列表
    userList: function(params) {
        return RequestServiceBase.get('itsm/v2/organization/user/list', params)
    },
    // 批量更新用户部门
    updateDepartment: function(params) {
        return RequestServiceBase.post('itsm/v2/organization/user/update_department', params)
    },
    // 服务组添加用户
    updateGroup: function updateGroup(params) {
        return RequestService.post('organization/group/user_group/add', params)
    },
    // Cab组列表
    cabGroupList: function(params) {
        return RequestServiceBase.get('itsm/v1/organization/cab_group', params)
    },
}
